import React from 'react';
import './LoadingIndicator.css';

const LoadingIndicator: React.FC = () => {
  return (
    <div className="loading-indicator">
      <div className="message-item assistant">
        <div className="message-avatar">🤖</div>
        <div className="message-content">
          <div className="message-header">
            <span className="message-role">AI助手</span>
          </div>
          <div className="loading-animation">
            <div className="loading-dots">
              <span></span>
              <span></span>
              <span></span>
            </div>
            <span className="loading-text">正在思考中...</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoadingIndicator; 